import { render, staticRenderFns } from "./LeaderboardManualPointPopup.vue?vue&type=template&id=6dd3bd41&scoped=true&"
import script from "./LeaderboardManualPointPopup.vue?vue&type=script&lang=js&"
export * from "./LeaderboardManualPointPopup.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardManualPointPopup.vue?vue&type=style&index=0&id=6dd3bd41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3bd41",
  null
  
)

export default component.exports